module.exports = __webpack_public_path__ + "static/media/down.6ed085c5.svg";